import { ShieldUserIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

/** Marks a record as verified: a red outlined button with the shield. */
const VerifyIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  ({ tooltipTitle, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <IconButton
        ref={ref}
        color="outlinedPrimary"
        {...props}
        tooltipTitle={tooltipTitle ?? t('common.verify', 'Verify')}
      >
        <ShieldUserIcon color="inherit" />
      </IconButton>
    );
  },
);

VerifyIconButton.displayName = 'VerifyIconButton';
export default VerifyIconButton;
